import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { MatIconAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenuItem } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GithubIconComponent } from 'src/app/components/utils/github-icon/github-icon.component';
import { Application } from 'src/app/models/application.model';
import { ApiService } from 'src/app/services/api.service';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
  selector: 'app-company-product-github-pull-request-link',
  templateUrl: './company-product-github-pull-request-link.component.html',
  styleUrl: './company-product-github-pull-request-link.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.as-menu-item]': 'appearance() === "menu-item"',
  },
  imports: [MatIconAnchor, MatIcon, MatMenuItem, MatTooltip, GithubIconComponent],
})
export class CompanyProductGithubPullRequestLinkComponent {
  task_code = input.required<string>();
  company_product_id = input.required<number>();
  appearance = input<'icon-button' | 'menu-item'>('icon-button');

  private api = inject(ApiService);
  private permissions = inject(PermissionsService);

  private readonly organization = toSignal(
    toObservable(this.company_product_id).pipe(
      switchMap((company_product_id: number): Observable<string> => {
        const company_product_id_str = company_product_id.toString();

        if (!this.permissions.isBisualProductionTeamInCompanyProduct(company_product_id_str)) {
          return of('');
        }

        return this.api.getCompanyProductApplications(company_product_id_str).pipe(
          map((applications: Application[]): string => applications[0]?.git_organization_name ?? ''),
          catchError((): Observable<string> => of(''))
        );
      })
    ),
    { initialValue: '' }
  );

  protected readonly href = computed((): string => {
    const organization = this.organization();
    const organization_query = organization !== '' ? `org:${organization}` : '';

    return `https://github.com/pulls?q=${encodeURIComponent(`${this.task_code()} into ${organization_query}`)}`;
  });
}
